import { converSeverityRatingToText } from 'containers/Pages/Events/Layouts';
import filter from 'lodash/filter';
import dayjs from 'dayjs';
import { t } from 'i18next';

export const transFormCalendarTask = (taskList, ratings) => {
  const ratingValues = Object.values(ratings);

  const ratedTasks = [];

  ratingValues.forEach(rating => {
    const filteredTasks = filter(taskList, {
      severityRating: rating,
    }).map((item, index) => {
      const year = dayjs(item.date).year();
      const month = dayjs(item.date).month();
      const date = dayjs(item.date).date();
      return {
        id: index + 1,
        type: item.itemName,
        severityRating: rating,
        title: `${t(item?.itemName)} (${converSeverityRatingToText(rating)}) ${
          item.count
        }/${item.scheduledCount}`,
        start: new Date(year, month, date),
        end: new Date(year, month, date),
      };
    });

    ratedTasks.push(filteredTasks);
  });
  return ratedTasks.flatMap(f => f);
};
